import { LocationDetails, ReportLocationStats } from '@dev/ee-api/ee-api-models';
import { CustomTableRowsProps } from '@dev/ee-components';

export interface mapRowsParams {
    value: number;
    description: string;
}

export enum GeographyToggleBtnValues {
    Number = 'number',
    Percent = 'percent',
}

export enum WorldMapsEnum {
    World = 'world',
    USA = 'us',
    Canada = 'ca',
}
export interface GeographyWorldMapProps {
    selectedMap: WorldMapsEnum;
    setSelectedMap: (selectedMap: WorldMapsEnum) => void;
    setPage: (page) => void;
}
export interface ToggleButtonProps {
    setCountryStaticticsFormat: (newValue: GeographyToggleBtnValues) => void;
}

export interface SearchAndFilterProps {
    countryStatisticsFormat: GeographyToggleBtnValues;
    setCountryStatisticsFormat: (format: GeographyToggleBtnValues) => void;
    setSearchResult: (result) => void;
}

export interface TableWithCountryProps {
    perPage: number;
    page: number;
    setPerPage: (perPage) => void;
    setPage: (page) => void;
    selectedMap: WorldMapsEnum;
    countryStatisticsFormat: GeographyToggleBtnValues;
    countriesTableData: ReportLocationStats[] | LocationDetails[];
    setCountriesTableData: (countriesTableData: ReportLocationStats[] | LocationDetails[]) => void;
    searchResult: any[];
}

export interface MobileTableProps {
    rows: CustomTableRowsProps[];
    headers: string[];
    dataCount: number;
    text: string;
}
export interface GeographyToggleBtnOptInterface {
    label: string;
    value: GeographyToggleBtnValues;
}
